/** Outfit batch generates outfits given the batch */
import React from 'react';
import {Outfit} from '../outfit'

export class AuditedOutfits extends React.Component {
    constructor(props) {
        super(props);
        this.generateOutfits = this.generateOutfits.bind(this);
    }

    /**Creates an Outfit component with the corresponding items for each outfit in batch */
    generateOutfits() {
        const currentBatch = []
        for (let i = 0; i < this.props.batch.length; i++) {
            currentBatch.push(
                <div key={i} className="awsui-util-mb-l">
                    <Outfit 
                    user = {this.props.user}
                    outfitInfo={this.props.batch[i]} 
                    batchNum={i}
                    storeAudit={this.props.storeAuditBatch}
                    saveReAudit={this.props.saveReAudit}
                    enableReEdit={true}/>
                </div> 
            )
        }
        if (currentBatch.length == 0) {
            return (
                <center>
                    <h2>No Outfits Loaded</h2>
                </center>
            );
        }

        return currentBatch
    }

    render() {
        return (
            <div>
                <div className="awsui-util-ml-l">
                    <h1>Browse Audited Outfits</h1>
                </div>
                <div>
                    {this.generateOutfits()}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/browsePage/auditedOutfits.jsx